<template>
    <h1>{{ title || 'Reset Password' }}</h1>
    <div :class="{'loading': loading}">
        <div v-if="status" :class="['alert', 'alert-' + status]" role="alert" v-html="message"></div>
        <div v-if="!model.state" class="col-md-6 m-auto">
            <div class="form-floating my-4">
                <input type="password" v-model="model.password" class="form-control" @keyup.enter="submit" autofocus placeholder="Password" required>
                <label for="password" class="text-start">Password</label>
            </div>
            <div class="form-floating">
                <input type="password" v-model="model.confirmPassword" class="form-control" @keyup.enter="submit" autofocus placeholder="Confirm password" required>
                <label for="confirmPassword" class="text-start">Confirm password</label>
            </div>
            <div class="my-4 text-center">
                <button class="btn btn-lg btn-primary w-100" @click="submit" role="button" :disabled="loading">
                    <i class="fa fa-circle-notch fa-spin m-1" loading></i>Submit<i class="fa fa-invisible m-1"></i>
                </button>
            </div>
        </div>
        <div v-if="model.state == 'complete'" class="col-md-6 m-auto">
            <div class="m-4 text-center">
                <a v-if="signin" class="btn btn-lg btn-success w-100" href="/dashboard">
                    Proceed to Dashboard <i class="fa fa-arrow-right mx-3"></i>
                </a>
                <a v-else class="btn btn-lg btn-success w-100" href="/signin">
                    Proceed to sign in <i class="fa fa-arrow-right mx-3"></i>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        props: ['id', 'mkey', 'recaptchakey', 'signin', 'title'],
        data: function () {
            return {
                model: {
                    id: null,
                    key: null,
                    password: null,
                    confirmPassword: null,
                    state: null,
                },
                status: '',
                message: '',
                loading: false,
            };
        },
        created() {
            this.model.id = this.id;
            this.model.key = this.mkey;
        },
        methods: {
            submit() {
                const vm = this;
                grecaptcha.enterprise.ready(async () => {
                    const token = await grecaptcha.enterprise.execute(vm.recaptchakey, { action: 'resetpassword' });
                    vm.model.recaptchaToken = token;
                    vm.loading = true;
                    axios.post(vm.signin ? '/users/invitation' : '/signin/reset', vm.model).then(result => {
                        var data = result.data;
                        vm.message = data.message;
                        vm.model = data.model;
                        vm.status = data.status;
                    }).catch(error => {
                        vm.showError(error);
                    }).finally(() => {
                        vm.loading = null;
                    });
                });
            },
            showError(error) {
                this.message = `Oops! Something didn't go as planned. The actual error was:<br><b>"${error}"<b>`;
                this.status = 'danger';
            },
        }
    };
</script>